import pt from './pt'
import en from './en'
import es from './es'

const messages = {
    'pt-BR': pt,
    'en-US': en,
    'es-ES': es
}

export default messages
